<template>
    <div class="data-detail-body">

        <Message severity="info" sticky :closable="false">
            A prioridade é definida de cima para baixo. Arraste as configurações para ordená-las e, dentro de cada
            uma, arraste os fornecedores para definir qual é tentado primeiro.
        </Message>

        <Draggable v-model="state.sortedPriorityConfigurations" class="priority-board" item-key="id">
            <template #item="{ element: configuration }">

                <div class="priority-config">

                    <div class="priority-config-title">
                        <i class="pi pi-bars"></i>
                        <span class="pill pill-muted">ID {{ configuration.id }}</span>
                        <span>{{ configuration.vendors.length }} {{ configuration.vendors.length === 1 ? 'fornecedor' : 'fornecedores' }}</span>
                    </div>

                    <Draggable v-model="configuration.vendors" class="priority-vendors" item-key="id">

                        <template #item="{ element: vendor }">
                            <span class="pill pill-info priority-vendor"
                                :title="vendor.active ? vendor.name : `${vendor.name} (fornecedor inativo)`">
                                {{ vendor.name }}
                            </span>
                        </template>

                    </Draggable>

                </div>
            </template>
        </Draggable>

    </div>

    <div class="data-form-footer px-4 pb-4">
        <Button class="p-button-text" type="button" label="Cancelar" @click="$emit('closeUpdateModal')" />
        <Button :loading="state.updatingPriority" :disabled="state.updatingPriority" type="button"
            label="Salvar prioridade" icon="pi pi-check" @click="updatePriority" />
    </div>
</template>

<script>
import { reactive } from 'vue'
import Draggable from 'vuedraggable'
import { useStore } from 'vuex'
import useNotificationToast from '../../../composables/useNotificationToast'
import services from '../../../services'
import Button from 'primevue/button'
import Message from 'primevue/message'

export default {

    props: {
        configurations: {
            type: Array
        }
    },

    components: {
        Draggable,
        Button,
        Message
    },

    emits: ['closeUpdateModal'],

    setup(props, context) {

        const state = reactive({
            sortedPriorityConfigurations: [],
            updatingPriority: false
        })

        // cópia profunda: arrastar não pode reordenar a lista da tela antes de salvar
        state.sortedPriorityConfigurations = JSON.parse(JSON.stringify(props.configurations))

        const store = useStore()
        const { success, error } = useNotificationToast()

        async function updatePriority() {

            state.updatingPriority = true

            const token = store.getters.getToken

            await services.configurations.prioritize({ newPriorityConfigurationsOrder: state.sortedPriorityConfigurations, token })
                .then(() => {
                    success('Configuração atualizada com sucesso!')
                    context.emit('closeUpdateModal')
                })
                .catch(() => {
                    error("Não foi possível atualizar as prioridades de configuração.")
                })
                .finally(() => { state.updatingPriority = false })
        }

        return {
            state,
            updatePriority
        }


    }

}
</script>
